import providers from "./providers.json";
export const POS_PROVIDERS = providers;
export function normalizeProvider(value = "lightspeed") {
  const key = String(value || "lightspeed").trim().toLowerCase();
  return ({ls:"lightspeed", lightspeed_retail:"lightspeed", future:"future_pos", "future-pos":"future_pos"})[key] || key;
}
export function getPosProvider(value) {
  const id = normalizeProvider(value);
  return providers.find(p => p.id === id) || {id, label:id, available:false, stockBalance:"unverified", setupMessage:"This provider has no installed connector."};
}
export function validatePosSnapshot(data, provider, siteId) {
  if (data?.ok !== true || normalizeProvider(data.provider) !== normalizeProvider(provider)) throw new Error("POS sync returned an invalid provider response. Previous inventory was preserved.");
  if (String(data.mcSiteId || "") !== String(siteId)) throw new Error("POS sync returned a different site. Previous inventory was preserved.");
  if (data.complete !== true || data.stockBalance !== "pos") throw new Error("This provider has not supplied a complete stock balance for counting. Previous inventory was preserved.");
  if (!Array.isArray(data.rows)) throw new Error("POS sync returned no valid inventory rows.");
  if (data.rows.some(row => row.systemSoh === null || row.systemSoh === undefined || row.systemSoh === "" || !Number.isFinite(Number(row.systemSoh)))) throw new Error("POS stock quantities are missing or invalid. Previous inventory was preserved.");
}
